//////////////////////////////////////////////////////////////////////////////
//
//  Attendance API
//
//  작성자: MediInStep Team
//  생성일: 2026-02-09
//
//  설명: 출석 관리 관련 API 정의
//
//////////////////////////////////////////////////////////////////////////////

import { ApiGroup } from "../types/ApiTypes"

/**
 * 출석 관리 관련 API
 */
const AttendanceAPI: ApiGroup = {
    pagedList: {
        title: "출석 목록 조회",
        url: "/Attendance/paged-list",
        method: "GET",
        paramz: {},
    },
}

export default AttendanceAPI
